const texts = [
  "Este site é mantido e operado por Diocese de Joinville (Mitra Diocesana de Joinville).",
  "Nós coletamos e utilizamos alguns dados pessoais que pertencem àqueles que utilizam nosso site. Ao fazê-lo, agimos na qualidade de controlador desses dados e estamos sujeitos às disposições da Lei Federal n. 13.709/2018 (Lei Geral de Proteção de Dados Pessoais - LGPD).",
  "Nós cuidamos da proteção de seus dados pessoais e, por isso, disponibilizamos esta política de privacidade, que contém informações importantes sobre:",
  {
    texts: [
      "- Quem deve utilizar nosso site",
      "- Quais dados coletamos e o que fazemos com eles;",
      "- Seus direitos em relação aos seus dados pessoais; e",
      "- Como entrar em contato conosco.",
    ],
  },
  {
    text: "1. Quem deve utilizar nosso site",
    bold: true,
  },
  "Nosso site somente deve ser utilizado por pessoas que tenham, pelo menos, 10 (dez) anos de idade, sendo que a utilização por pessoa com menos de 18 (dezoito) anos somente será possível mediante o consentimento de pelo menos um de seus pais ou responsável.",
  {
    text: "2. Dados que coletamos e motivos da coleta",
    bold: true,
  },
  "Nosso site coleta e utiliza alguns dados pessoais de nossos usuários, de acordo com o disposto nesta seção.",
  {
    text: "1. Dados pessoais fornecidos expressamente pelo usuário",
    subTitle: true,
  },
  "Nós coletamos os seguintes dados pessoais que nossos usuários nos fornecem expressamente ao utilizar nosso site:",
  {
    texts: [
      "Nome completo;",
      "Endereço de e-mail;",
      "CPF;",
      "Endereço residencial.",
    ],
  },
  "A coleta destes dados ocorre nos seguintes momentos:",
  {
    texts: [
      "No momento do Cadastro para acesso à Studium;",
      "No pagamento de cursos.",
    ],
  },
  "Os dados fornecidos por nossos usuários são coletados com as seguintes finalidades:",
  {
    texts: [
      "Garantir ao usuário o acesso à sua conta Studium para conhecimento, acesso, pagamento e realização dos cursos disponíveis, entre outras funcionalidades.",
    ],
  },
  {
    text: "2. Dados sensíveis",
    subTitle: true,
  },
  "Não serão coletados dados sensíveis de nossos usuários, assim entendidos aqueles definidos nos arts. 11 e seguintes da Lei de Proteção de Dados Pessoais. Assim, não haverá coleta de dados sobre origem racial ou étnica, convicção religiosa, opinião política, filiação a sindicato ou a organização de caráter religioso, filosófico ou político, dado referente à saúde ou à vida sexual, dado genético ou biométrico, quando vinculado a uma pessoa natural.",
  {
    text: "3. Cookies",
    subTitle: true,
  },
  "Cookies são pequenos arquivos de texto baixados automaticamente em seu dispositivo quando você acessa e navega por um site. Eles servem, basicamente, para seja possível identificar dispositivos, atividades e preferências de usuários.",
  "Os cookies não permitem que qualquer arquivo ou informação sejam extraídos do disco rígido do usuário, não sendo possível, ainda, que, por meio deles, se tenha acesso a informações pessoais que não tenham partido do usuário ou da forma como utiliza os recursos do site.",
  {
    text: "a. Cookies do site",
    subTitle: true,
  },
  "Os cookies do site são aqueles enviados ao computador ou dispositivo do usuário e administrador exclusivamente pelo site.",
  "As informações coletadas por meio destes cookies são utilizadas para melhorar e personalizar a experiência do usuário, sendo que alguns cookies podem, por exemplo, ser utilizados para lembrar as preferências e escolhas do usuário, bem como para o oferecimento de conteúdo personalizado.",
  {
    text: "b. Gestão de cookies",
    subTitle: true,
  },
  "O usuário poderá se opor ao registro de cookies pelo site, bastando que desative esta opção no seu próprio navegador. Mais informações sobre como fazer isso em alguns dos principais navegadores utilizados hoje podem ser acessadas a partir dos seguintes links:",
  {
    texts: [
      "Internet Explorer:",
      "https://support.microsoft.com/pt-br/help/17442/windows-internet-explorer-delete-manage-cookies",
      "Safari:",
      "https://support.apple.com/pt-br/guide/safari/sfri11471/mac",
      "Google Chrome:",
      "https://support.google.com/chrome/answer/95647?hl=pt-BR&hlrm=pt",
      "Mozila Firefox:",
      "https://support.mozilla.org/pt-BR/kb/ative-e-desative-os-cookies-que-os-sites-usam",
      "Opera:",
      "https://www.opera.com/help/tutorials/security/privacy/",
    ],
  },
  "A desativação dos cookies, no entanto, pode afetar a disponibilidade de algumas ferramentas e funcionalidades do site, comprometendo seu correto e esperado funcionamento. Outra consequência possível é remoção das preferências do usuário que eventualmente tiverem sido salvas, prejudicando sua experiência.",
  {
    text: "4. Coleta de dados não previstos expressamente",
    subTitle: true,
  },
  "Eventualmente, outros tipos de dados não previstos expressamente nesta Política de Privacidade poderão ser coletados, desde que sejam fornecidos com o consentimento do usuário, ou, ainda, que a coleta seja permitida com fundamento em outra base legal prevista em lei.",
  "Em qualquer caso, a coleta de dados e as atividades de tratamento dela decorrentes serão informadas aos usuários do site.",

  {
    text: "3. Compartilhamento de dados pessoais com terceiros",
    bold: true,
  },
  "Nós não compartilhamos seus dados pessoais com terceiros. Apesar disso, é possível que o façamos para cumprir alguma determinação legal ou regulatória, ou, ainda, para cumprir alguma ordem expedida por autoridade pública.",
  {
    text: "4. Por quanto tempo seus dados pessoais serão armazenados",
    bold: true,
  },
  "Os dados pessoais coletados pelo site são armazenados e utilizados por período de tempo que corresponda ao necessário para atingir as finalidades elencadas neste documento e que considere os direitos de seus titulares, os direitos do controlador do site e as disposições legais ou regulatórias aplicáveis.",
  "Uma vez expirados os períodos de armazenamento dos dados pessoais, eles são removidos de nossas bases de dados ou anonimizados, salvo nos casos em que houver a possibilidade ou a necessidade de armazenamento em virtude de disposição legal ou regulatória.",
  {
    text: "5. Bases legais para o tratamento de dados pessoais",
    bold: true,
  },
  "Uma base legal para o tratamento de dados pessoais nada mais é que um fundamento jurídico, previsto em lei, que justifica o justifica. Assim, cada operação de tratamento de dados pessoais precisa ter uma base legal a ela correspondente.",
  "Nós tratamos os dados pessoais de nossos usuários nas seguintes hipóteses:",
  {
    texts: [
      "- mediante o consentimento do titular dos dados pessoais",
      "- para o exercício regular de direitos em processo judicial, administrativo ou arbitral",
      "- quando necessário para atender aos interesses legítimos do controlador ou de terceiro",
    ],
  },
  {
    text: "1. Consentimento",
    subTitle: true,
  },
  "Determinadas operações de tratamento de dados pessoais realizadas em nosso site dependerão da prévia concordância do usuário, que deverá manifestá-la de forma livre, informada e inequívoca.",
  "O usuário poderá revogar seu consentimento a qualquer momento, sendo que, não havendo hipótese legal que permita ou que demande o armazenamento dos dados, os dados fornecidos mediante consentimento serão excluídos.",
  "Além disso, se desejar, o usuário poderá não concordar com alguma operação de tratamento de dados pessoais baseada no consentimento. Nestes casos, porém, é possível que não possa utilizar alguma funcionalidade do site que dependa daquela operação. As consequências da falta de consentimento para uma atividade específica são informadas previamente ao tratamento.",
  {
    text: "2. Legítimo interesse",
    subTitle: true,
  },
  'Para determinadas operações de tratamento de dados pessoais, nos baseamos exclusivamente em nosso interesse legítimo. Para saber mais sobre em quais casos, especificamente, nos valemos desta base legal, ou para obter mais informações sobre os testes que fazemos para termos certeza de que podemos utilizá-la, entre em contato com nosso Encarregado de Proteção de Dados Pessoais por algum dos canais informados nesta Política de Privacidade, na seção "Como entrar em contato conosco".',
  {
    text: "6. Direitos do usuário",
    bold: true,
  },
  "O usuário do site possui os seguintes direitos, conferidos pela Lei de Proteção de Dados Pessoais:",
  {
    texts: [
      "- confirmação da existência de tratamento;",
      "- acesso aos dados;",
      "- correção de dados incompletos, inexatos ou desatualizados;",
      "- anonimização, bloqueio ou eliminação de dados desnecessários, excessivos ou tratados em desconformidade com o disposto na lei;",
      "- portabilidade dos dados a outro fornecedor de serviço ou produto, mediante requisição expressa, de acordo com a regulamentação da autoridade nacional, observados os segredos comercial e industrial;",
      "- eliminação dos dados pessoais tratados com o consentimento do titular, exceto nos casos previstos em lei;",
      "- informação das entidades públicas e privadas com as quais o controlador realizou uso compartilhado de dados;",
      "- informação sobre a possibilidade de não fornecer consentimento e sobre as consequências da negativa;",
      "- revogação do consentimento.",
    ],
  },
  "É importante destacar que, nos termos da LGPD, não existe um direito de eliminação de dados tratados com fundamento em bases legais distintas do consentimento, a menos que os dados seja desnecessários, excessivos ou tratados em desconformidade com o previsto na lei.",
  {
    text: "1. Como o titular pode exercer seus direitos",
    subTitle: true,
  },
  "Para garantir que o usuário que pretende exercer seus direitos é, de fato, o titular dos dados pessoais objeto da requisição, poderemos solicitar documentos ou outras informações que possam auxiliar em sua correta identificação, a fim de resguardar nossos direitos e os direitos de terceiros. Isto somente será feito, porém, se for absolutamente necessário, e o requerente receberá todas as informações relacionadas.",
  {
    text: "7. Medidas de segurança no tratamento de dados pessoais",
    bold: true,
  },
  "Empregamos medidas técnicas e organizativas aptas a proteger os dados pessoais de acessos não autorizados e de situações de destruição, perda, extravio ou alteração desses dados.",
  "As medidas que utilizamos levam em consideração a natureza dos dados, o contexto e a finalidade do tratamento, os riscos que uma eventual violação geraria para os direitos e liberdades do usuário, e os padrões atualmente empregados no mercado por empresas semelhantes à nossa.",
  "Entre as medidas de segurança adotadas por nós, destacamos as seguintes:",
  {
    text: "Ferramentas de criptografia e restrições de acesso aos dados.",
  },
  "Ainda que adote tudo o que está ao seu alcance para evitar incidentes de segurança, é possível que ocorra algum problema motivado exclusivamente por um terceiro - como em caso de ataques de hackers ou crackers ou, ainda, em caso de culpa exclusiva do usuário, que ocorre, por exemplo, quando ele mesmo transfere seus dados a terceiro. Assim, embora sejamos, em geral, responsáveis pelos dados pessoais que tratamos, nos eximimos de responsabilidade caso ocorra uma situação excepcional como essas, sobre as quais não temos nenhum tipo de controle.",
  "De qualquer forma, caso ocorra qualquer tipo de incidente de segurança que possa gerar risco ou dano relevante para qualquer de nossos usuários, comunicaremos os afetados e a Autoridade Nacional de Proteção de Dados acerca do ocorrido, em conformidade com o disposto na Lei Geral de Proteção de Dados.",
  {
    text: "8. Reclamação a uma autoridade de controle",
    bold: true,
  },
  "Sem prejuízo de qualquer outra via de recurso administrativo ou judicial, os titulares de dados pessoais que se sentirem, de qualquer forma, lesados, podem apresentar reclamação à Autoridade Nacional de Proteção de Dados.",
  {
    text: "9. Alterações nesta política",
    bold: true,
  },
  "A presente versão desta Política de Privacidade foi atualizada pela última vez em: 16/02/2021.",
  "Reservamo-nos o direito de modificar, a qualquer momento, as presentes normas, especialmente para adaptá-las às eventuais alterações feitas em nosso site, seja pela disponibilização de novas funcionalidades, seja pela supressão ou modificação daquelas já existentes.",
  "Sempre que houver uma modifição, nossos usuários serão notificados acerca da mudança.",
  {
    text: "10. Como entrar em contato conosco",
    bold: true,
  },
  "Para esclarecer quaisquer dúvidas sobre esta Política de Privacidade ou sobre os dados pessoais que tratamos, entre em contato com nosso Encarregado de Proteção de Dados Pessoais, por algum dos canais mencionados abaixo:",
  {
    texts: [
      "Telefone: (047) 3551-3700 - Cúria Diocesana de Joinville",
      "Endereço: Rua: Jaguaruna, 147 - Centro - Joinville/SC",
    ],
  },
];

export default texts;
